import FormatTime from "../utils/FormatTime";
import { useState, useEffect } from "react";
import ParseTime from "../utils/ParseTime";
import { motion } from "framer-motion";

function ProjectHistory({ setHistory, history, historyDatabseId }) {
  const [isLoading, setIsLoading] = useState(!history.length);

  useEffect(() => {
    if (!historyDatabseId) return;
    

    async function fetchHistory() {
      setIsLoading(!history.length);

      const res = await fetch(
        "https://time-api.web-hub.online/api/project-history?database_id=" +
          historyDatabseId
      ).finally(() => {
        setIsLoading(false);
      });

      const data = await res.json();

      const grouped = {};

      data?.items.forEach((item) => {
        const date = item.properties?.Date?.title?.[0]?.plain_text;
        const timeStr =
          item.properties?.["Time spent"]?.rich_text?.[0]?.plain_text;

        if (!date || !timeStr) return;

        const time = ParseTime(timeStr);

        if (!grouped[date]) {
          grouped[date] = time;
        } else {
          grouped[date] += time;
        }
      });

      const result = Object.entries(grouped)
        .map(([date, time]) => ({ date, time }))
        .sort((a, b) => new Date(b.date) - new Date(a.date));

      setHistory(result);
    }

    fetchHistory();
  }, [historyDatabseId]);

  const sortedHistory = [...(history || [])].sort((a, b) => {
    const parseDate = (str) => {
      const [day, month, year] = str.split(".");
      return new Date(year, month - 1, day); // JS months 0-11
    };

    return parseDate(b.date) - parseDate(a.date); // новые сверху
  });

  return isLoading ? (
    <div className="flex justify-center items-center h-20">
      <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-500"></div>
    </div>
  ) : !isLoading && sortedHistory.length ? (
    sortedHistory.map((item) => (
      <div
        className="grid grid-cols-[140px_1fr] gap-14 py-3 px-5 mt-2 rounded-2xl bg-[#F7F9FC]"
        key={item.id}
      >
        <div className="text-sm font-semibold flex items-center gap-2">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 6.97333H15M11.8889 1V3.98667M4.11111 1V3.98667M11.8889 2.49333H4.11111C3.28599 2.49333 2.49467 2.808 1.91122 3.36811C1.32778 3.92822 1 4.68789 1 5.48V12.0133C1 12.8054 1.32778 13.5651 1.91122 14.1252C2.49467 14.6853 3.28599 15 4.11111 15H11.8889C12.714 15 13.5053 14.6853 14.0888 14.1252C14.6722 13.5651 15 12.8054 15 12.0133V5.48C15 4.68789 14.6722 3.92822 14.0888 3.36811C13.5053 2.808 12.714 2.49333 11.8889 2.49333Z"
              stroke="#5489DA"
              strokeWidth="1.5"
            />
          </svg>
          <span>{item.date}</span>
        </div>
        <div className="text-sm font-semibold flex items-center gap-2">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.95833 15.0417C11.8473 15.0417 15 11.8891 15 8.00005C15 4.11104 11.8473 0.958374 7.95833 0.958374C4.06932 0.958374 0.916656 4.11104 0.916656 8.00005C0.916656 11.8891 4.06932 15.0417 7.95833 15.0417Z"
              stroke="#5489DA"
              strokeWidth="1.5"
            />
            <path
              d="M11.6863 8.00004H8.16545C8.11052 8.00004 8.05784 7.97822 8.019 7.93938C7.98016 7.90054 7.95834 7.84786 7.95834 7.79293V5.10052"
              stroke="#5489DA"
              strokeWidth="1.5"
            />
          </svg>
          <span>{FormatTime(item.time)}</span>
        </div>
      </div>
    ))
  ) : (
    <span className="mb-5">Not found</span>
  );
}

export default ProjectHistory;
